import Dependencies from '../utilities/dependencies';

export default class  Header {

	/**
	 * CSS selectors that must exist for this module to run
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getHolderSelectors = () => ['header.desktop-view'];

	/**
	 * Dependencies that this module requires
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getDependencies = () => [Dependencies.libraries.vimeo];

	/**
	 * Runtime injected CSS classes
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getClassList = () => Object.create({});

	/** @type {HTMLElement} */
	#holderElement;

	/** @type {HTMLElement} */
	#headerContainer;

	/** @type {HTMLElement} */
	#bookingButton;

	/** @type {HTMLElement} */
	#bookingSearchFormElement;

	/** @type {HTMLElement} */
	#closeBtns;

	/** @type {HTMLElement} */
	#menuItems;

	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		if (window.innerWidth > 480) {
			this.#holderElement = holderElement;
			this.#headerContainer = this.#holderElement.querySelector('.container-fluid');
			this.#bookingButton = this.#holderElement.querySelector('.open-booking-search-form-view');
			this.#bookingSearchFormElement = document.querySelector('.booking-search-form-wrapper');
			this.#closeBtns = this.#bookingSearchFormElement.querySelectorAll('.btn-close');
			this.#menuItems = this.#holderElement.querySelectorAll('.menu-item-wrapper');
			this.desktopOnload();
		}
	}

	desktopOnload() {
		// this.#toggleMobMenu(this.#holderElement);
		this.#shrinkHeader();
		this.#handleMenuItems();
		this.#handleBookingBtn();
	}

	#shrinkHeader() {
		let self = this;

		if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
			this.#headerContainer.classList.add('smaller');
		} else {
			this.#headerContainer.classList.remove('smaller');
		}

		window.addEventListener('scroll', function (){
			if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
				self.#headerContainer.classList.add('smaller');
			} else {
				self.#headerContainer.classList.remove('smaller');
			}
		});
	}

	#handleMenuItems() {
		this.#menuItems.forEach((menuItem) => {
			const subMenuItem = menuItem.querySelector('.submenu-wrapper');

			if (subMenuItem) {
				menuItem.addEventListener('mouseover', (event) => {
					event.preventDefault();
					subMenuItem.style.height = subMenuItem.scrollHeight.toString() + 'px';
					subMenuItem.style.visibility = 'visible';
				});
				menuItem.addEventListener('mouseout', (event) => {
					event.preventDefault();
					subMenuItem.style.height = '0';
					subMenuItem.style.visibility = 'hidden';
				});
			}
		});
	}

	#handleBookingBtn() {
		let self = this;
		this.#bookingButton.addEventListener('click', function (){
			document.querySelector('html').style.overflow = 'hidden';
			self.#bookingSearchFormElement.style.height = '100vh';
			self.#bookingSearchFormElement.style.zIndex = '11';
			self.#closeBtns.forEach((closeBtn)  => {
				closeBtn.style.display = 'inline-block';
			});
			self.#bookingSearchFormElement.querySelector('.next-button-wrapper').style.position = 'fixed';
			self.#bookingSearchFormElement.querySelector('.btn-next').style.position = 'fixed';
			self.#bookingSearchFormElement.querySelector('.btn-submit').style.position = 'fixed';
			self.#bookingSearchFormElement.querySelector('.btn-next').style.opacity = 1;
			self.#bookingSearchFormElement.querySelector('.btn-submit').style.opacity = 1;
			self.#bookingSearchFormElement.querySelectorAll('.booking-search-form-option').forEach(option => {
				option.querySelector('svg').style.opacity = '1';
			});
			if (document.querySelector('.booking-search-form-wrapper').querySelector('.booking-search-form-selection-wrapper.active').getAttribute('id') !== 'selection-0') {
				self.#bookingSearchFormElement.querySelector('.btn-back').style.display = 'inline-block';
			}
		});
	}
}
